module.exports = __webpack_public_path__ + "img/fig12.d966b9d8.jpg";